export default "<button data-ar=\"toggle\" data-binding=\"arButton\" class=\"btn btn-block btn-primary btn-ar\" href=\"#\"></button>";